module.exports = __webpack_public_path__ + "img/my-story-hotel-ouro.860adfa5.jpg";